import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "account-asset"
};
var _hoisted_2 = {
  class: "account-my-title"
};
var _hoisted_3 = {
  class: "account-my-list"
};
var _hoisted_4 = {
  class: "item-header"
};
var _hoisted_5 = {
  class: "item-text"
};
var _hoisted_6 = {
  class: "price"
};
var _hoisted_7 = {
  class: "currency"
};
var _hoisted_8 = {
  class: "item-header"
};
var _hoisted_9 = {
  class: "item-text"
};
var _hoisted_10 = {
  class: "ununsed"
};
var _hoisted_11 = {
  class: "ununsed-number"
};
var _hoisted_12 = {
  class: "item-header"
};
var _hoisted_13 = {
  class: "item-text"
};
var _hoisted_14 = {
  class: "ununsed"
};
var _hoisted_15 = {
  class: "ununsed-number"
};
import { PriceStrCurrencySymbolEnum } from "@/constant/currency";
import { useRouter } from "@/hooks/useRouter";
import { useUserStore } from "@/store/userStore";
import { priceUtil } from "@op/shared";
export default {
  __name: 'AccountAsset',
  setup: function setup(__props) {
    var userStore = useUserStore();
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var toMyBalance = function toMyBalance() {
      routerPush({
        name: "MyBalance"
      });
    };
    var toRewards = function toRewards() {
      routerPush({
        name: "Rewards"
      });
    };
    function toMyCounponList() {
      routerPush({
        name: "MyCouponList"
      });
    }
    return function (_ctx, _cache) {
      var _component_SvgIcon = _resolveComponent("SvgIcon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("myAccount")), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "item",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return toMyBalance();
        })
      }, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_SvgIcon, {
        name: "wallet",
        size: 20,
        class: "item-img"
      }), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("wallet")), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_unref(PriceStrCurrencySymbolEnum)[_unref(userStore).getWalletCurrency]), 1), _createTextVNode(_toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(_unref(userStore).getWallet, _unref(userStore).getWalletCurrency, false)), 1)])]), _createElementVNode("div", {
        class: "item",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return toRewards();
        })
      }, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_SvgIcon, {
        name: "point",
        size: 20,
        class: "item-img"
      }), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("points")), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(_unref(userStore).getPoints), 1), _createTextVNode(_toDisplayString(_ctx.$t("unusedLowercase")), 1)])]), _createElementVNode("div", {
        class: "item",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return toMyCounponList();
        })
      }, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_SvgIcon, {
        name: "voucher",
        size: 20,
        class: "item-img"
      }), _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("vouchers")), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(userStore).getVouchers), 1), _createTextVNode(_toDisplayString(_ctx.$t("unusedLowercase")), 1)])])])]);
    };
  }
};